(function (global) {
  'use strict';

  var SIZE_WAIST = { XS: 26, S: 28, M: 30, L: 32, XL: 34, XXL: 36, '2XL': 36, '3XL': 38, '4XL': 40 };

  function bySize(rows) {
    return (rows || []).slice();
  }

  function confidence(model, mode, hasNumericWaist) {
    var value = (model.lineage && model.lineage.confidence) || 'low';
    if (mode === 'quick') value = hasNumericWaist && value === 'high' ? 'medium' : 'low';
    if (model.rules && model.rules.waist_mode === 'elastic' && !Object.keys(model.rules.waist_stretched_max_by_size_cm || {}).length && value === 'high') value = 'medium';
    return value;
  }

  function lengthGuidance(model, selected, height) {
    if (!height) return 'Length: check garment outseam';
    var anchor = (model.rules.model_anchors || []).find(function (item) { return item.height_cm && item.supplier_size; });
    if (!anchor) return 'Length: check garment outseam';
    var anchorRow = (model.chart.sizes || []).find(function (item) { return item.supplier_size === anchor.supplier_size; });
    if (!anchorRow) return 'Length: check garment outseam';
    var residual = (Number(selected.outseam_cm) - Number(anchorRow.outseam_cm)) - ((Number(height) - Number(anchor.height_cm)) * 0.45);
    if (residual > 3) return 'Length: likely long';
    if (residual < -3) return 'Length: likely short';
    return 'Length: standard';
  }

  function precise(model, input) {
    var rules = model.rules || {};
    var rows = bySize(model.chart && model.chart.sizes);
    var stretch = rules.waist_stretched_max_by_size_cm || {};
    var hipTarget = Number((rules.hip_ease_by_preference_cm || {})[input.preference] || 8);
    var waistMinimum = rules.waist_mode === 'elastic' ? 0 : Number(rules.waist_ease_min_cm || 2);
    var basis = (model.chart && model.chart.measurement_basis) || 'garment_circumference_cm';
    var selected = rows.find(function (row) {
      if (basis === 'body_fit_range_cm') {
        return Number(row.waist_min_cm) <= input.waist && input.waist <= Number(row.waist_max_cm) && Number(row.hip_min_cm) <= input.hip && input.hip <= Number(row.hip_max_cm);
      }
      var capacity = Number(stretch[row.supplier_size] || row.waist_cm);
      return capacity >= input.waist + waistMinimum && Number(row.hip_cm) >= input.hip + hipTarget;
    });
    var warning = '';
    if (!selected && rows.length && basis !== 'body_fit_range_cm') {
      var largest = rows[rows.length - 1];
      var largestCapacity = Number(stretch[largest.supplier_size] || largest.waist_cm);
      if (input.waist <= largestCapacity && Number(largest.hip_cm) >= input.hip + Number(rules.maximum_size_fallback_hip_ease_cm || 4)) {
        selected = largest;
        warning = 'Closer fit than requested. Confirm the size risk before adding to cart.';
      }
    }
    if (!selected) return { status: 'no_reliable_fit', confidence: confidence(model, 'precise', true), message: 'No available size safely meets both waist and hip requirements.' };
    var capacity = basis === 'body_fit_range_cm' ? Number(selected.waist_max_cm) : Number(stretch[selected.supplier_size] || selected.waist_cm);
    var hipCapacity = basis === 'body_fit_range_cm' ? Number(selected.hip_max_cm) : Number(selected.hip_cm);
    return {
      status: warning ? 'recommended_with_warning' : 'recommended',
      size: selected.supplier_size,
      confidence: confidence(model, 'precise', true),
      waistEase: Math.round((capacity - input.waist) * 10) / 10,
      hipEase: Math.round((hipCapacity - input.hip) * 10) / 10,
      length: lengthGuidance(model, selected, input.height),
      warning: warning,
      requiresRisk: Boolean(warning)
    };
  }

  function quick(model, input) {
    var waistIn = input.waistIn || SIZE_WAIST[input.usualSize];
    if (!waistIn) return { status: 'needs_precise', confidence: 'low', message: 'Enter a usual waist size or use Precise mode.' };
    var waist = Number(waistIn) * 2.54;
    var rules = model.rules || {};
    var stretch = rules.waist_stretched_max_by_size_cm || {};
    var waistMinimum = rules.waist_mode === 'elastic' ? 0 : Number(rules.waist_ease_min_cm || 2);
    var basis = (model.chart && model.chart.measurement_basis) || 'garment_circumference_cm';
    var selected = bySize(model.chart && model.chart.sizes).find(function (row) {
      if (basis === 'body_fit_range_cm') return Number(row.waist_min_cm) <= waist && waist <= Number(row.waist_max_cm);
      return Number(stretch[row.supplier_size] || row.waist_cm) >= waist + waistMinimum;
    });
    if (!selected) return { status: 'needs_precise', confidence: 'low', message: 'The available waist range is too close for a quick recommendation.' };
    return {
      status: 'recommended_low_precision',
      size: selected.supplier_size,
      confidence: confidence(model, 'quick', Boolean(input.waistIn)),
      length: lengthGuidance(model, selected, input.height),
      message: 'Quick estimate uses waist only. Add hip measurement for a precise recommendation.'
    };
  }

  function selectActualVariant(root, model, size, result) {
    var variant = (model.variants || []).find(function (item) { return item.size === size && item.available; });
    document.querySelectorAll('variant-radios input[type="radio"], .product-form__input input[type="radio"]').forEach(function (input) {
      if (input.value === size) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    document.querySelectorAll('variant-selects select, .product-form__input select').forEach(function (select) {
      var option = Array.from(select.options || []).find(function (item) { return item.value === size; });
      if (option) { select.value = size; select.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    if (variant) {
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) { input.value = variant.id; });
    }
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var properties = {
        '_fit_recommended_size': size,
        '_fit_rule_version': (model.lineage && model.lineage.chart_version) || ''
      };
      Object.keys(properties).forEach(function (name) {
        var field = form.querySelector('input[name="properties[' + name + ']"]');
        if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'properties[' + name + ']'; form.appendChild(field); }
        field.value = properties[name];
      });
    });
  }

  function render(root, model, result, usual) {
    var box = root.querySelector('[data-denim-fit-result]');
    var warning = root.querySelector('[data-denim-result-warning]');
    var risk = root.querySelector('[data-denim-risk]');
    box.hidden = false;
    root.querySelector('[data-denim-result-usual]').textContent = usual ? 'Usual Western size: ' + usual : '';
    if (!result.size) {
      root.querySelector('[data-denim-result-size]').textContent = 'No reliable fit available';
      root.querySelector('[data-denim-result-meta]').textContent = result.message;
      warning.hidden = true; risk.hidden = true; return;
    }
    root.querySelector('[data-denim-result-size]').textContent = 'For this style, choose: ' + result.size;
    root.querySelector('[data-denim-result-meta]').textContent = (result.length || '') + (result.hipEase !== undefined ? ' | Hip room: ' + result.hipEase + ' cm' : '');
    warning.textContent = result.warning || result.message || '';
    warning.hidden = !warning.textContent;
    risk.hidden = !result.requiresRisk;
    selectActualVariant(root, model, result.size, result);
  }

  function initialize(root) {
    var modelNode = root.querySelector('[data-denim-size-model]');
    if (!modelNode) return;
    var model;
    try { model = JSON.parse(modelNode.textContent); } catch (error) { return; }
    if (!model.chart || !model.chart.sizes || !model.chart.sizes.length) return;
    var availableSizes = (model.variants || []).filter(function (item) { return item.available; }).map(function (item) { return item.size; });
    if (availableSizes.length) model.chart.sizes = model.chart.sizes.filter(function (row) { return availableSizes.indexOf(row.supplier_size) !== -1; });
    var mode = 'quick';
    root.querySelectorAll('[data-denim-mode]').forEach(function (button) {
      button.addEventListener('click', function () {
        mode = button.dataset.denimMode;
        root.querySelectorAll('[data-denim-mode]').forEach(function (item) { var active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); });
        root.querySelectorAll('[data-denim-panel]').forEach(function (panel) { panel.hidden = panel.dataset.denimPanel !== mode; });
      });
    });
    root.querySelector('[data-denim-fit-form]').addEventListener('submit', function (event) {
      event.preventDefault();
      var form = event.currentTarget;
      var preference = form.elements.fit_preference.value;
      var result;
      var usual = form.elements.usual_size.value || (form.elements.usual_waist_in.value ? 'W' + form.elements.usual_waist_in.value : '');
      if (mode === 'precise') {
        var waist = Number(form.elements.waist_cm.value || 0); var hip = Number(form.elements.hip_cm.value || 0);
        if (waist < 40 || hip < 50) result = { status: 'needs_precise', confidence: 'low', message: 'Enter body waist and hip measurements in centimeters.' };
        else result = precise(model, { waist: waist, hip: hip, height: Number(form.elements.height_cm.value || 0), preference: preference });
      } else {
        result = quick(model, { usualSize: form.elements.usual_size.value, waistIn: Number(form.elements.usual_waist_in.value || 0), height: Number(form.elements.quick_height_cm.value || 0), preference: preference });
      }
      render(root, model, result, usual);
    });
  }

  function initializeProductShortcuts() {
    var finder = document.querySelector('[data-denim-fit-root]');
    var productForm = document.querySelector('product-form, .product-form');
    if (!finder || !productForm || document.querySelector('.denim-fit-shortcut')) return;
    var shortcut = document.createElement('button');
    shortcut.type = 'button';
    shortcut.className = 'denim-button denim-fit-shortcut';
    shortcut.textContent = 'Find my size';
    shortcut.addEventListener('click', function () {
      finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var firstInput = finder.querySelector('input, select, button');
      if (firstInput) window.setTimeout(function () { firstInput.focus(); }, 450);
    });
    productForm.parentNode.insertBefore(shortcut, productForm);
  }

  function initializeMobileCart() {
    if (!document.querySelector('[data-denim-fit-root]') || document.querySelector('.denim-mobile-cart')) return;
    var original = document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    if (!original) return;
    var title = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    var price = document.querySelector('.price .price-item--regular, .price .price-item--sale');
    var bar = document.createElement('div');
    bar.className = 'denim-mobile-cart';
    bar.innerHTML = '<div class="denim-mobile-cart__label"><strong></strong><span></span></div><button class="denim-button" type="button">Add to cart</button>';
    bar.querySelector('strong').textContent = title ? title.textContent.trim() : 'Selected style';
    bar.querySelector('span').textContent = price ? price.textContent.trim() : '';
    var button = bar.querySelector('button');
    button.disabled = original.disabled;
    button.addEventListener('click', function () { original.click(); });
    document.body.appendChild(bar);
    document.body.style.paddingBottom = '72px';
    var observer = new MutationObserver(function () { button.disabled = original.disabled; });
    observer.observe(original, { attributes: true, attributeFilter: ['disabled'] });
  }

  global.DenimFitRecommendation = { precise: precise, quick: quick };
  if (typeof document !== 'undefined') document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-denim-fit-root]').forEach(initialize);
    initializeProductShortcuts();
    initializeMobileCart();
  });
})(typeof globalThis !== 'undefined' ? globalThis : this);
